import { render, staticRenderFns } from "./OnboardingView.vue?vue&type=template&id=2abdf6e4&scoped=true&"
import script from "./OnboardingView.vue?vue&type=script&lang=js&"
export * from "./OnboardingView.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingView.vue?vue&type=style&index=0&id=2abdf6e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abdf6e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2abdf6e4')) {
      api.createRecord('2abdf6e4', component.options)
    } else {
      api.reload('2abdf6e4', component.options)
    }
    module.hot.accept("./OnboardingView.vue?vue&type=template&id=2abdf6e4&scoped=true&", function () {
      api.rerender('2abdf6e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/OnboardingView.vue"
export default component.exports